import { deleteApi, getApi, postApi } from "../configAxios";

export const getUnions = (params) => {
  return getApi("/admin/unions", { params });
};

export const createUnion = (data) => {
  return postApi("/admin/unions", data);
};

export const getUnionById = (id) => {
  return getApi(`/admin/unions/${id}`);
};

export const updateUnion = (id, data) => {
  return postApi(`/admin/unions/${id}`, data);
  // if using Laravel form-data with _method: "PUT"
};

export const deleteUnion = (id) => {
  return deleteApi(`/admin/unions/${id}`);
};

export const getDivisions = () => getApi("/locations/divisions");
export const getDistricts = (divisionId) =>
  getApi(`/locations/districts/${divisionId}`);
export const getUpazilas = (districtId) =>
  getApi(`/locations/upazilas/${districtId}`);
